var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("สรุปรายงานแบบสอบถาม")]),_c('br'),_c('ReportSurveyUDCS')],1)}
var staticRenderFns = []

export { render, staticRenderFns }